// source: mlmbox/client/confirmation/v1/confirmation_guest.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_confirmation_pb = require('../../../../mlmbox/type/confirmation_pb.js');
goog.object.extend(proto, mlmbox_type_confirmation_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest', null, global);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field', null, global);
goog.exportSymbol('proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.displayName = 'proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest;
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFieldId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 field_id = 1;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.prototype.getFieldId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestGenerateOneTimePasswordRequest.prototype.setFieldId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    fieldsList: jspb.Message.toObjectList(msg.getFieldsList(),
    proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest;
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionId(value);
      break;
    case 2:
      var value = new proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field;
      reader.readMessage(value,proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.deserializeBinaryFromReader);
      msg.addFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field;
  return proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFieldId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 field_id = 1;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.getFieldId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.setFieldId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 option_id = 1;
 * @return {number}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.getOptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.setOptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Field fields = 2;
 * @return {!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field>}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.getFieldsList = function() {
  return /** @type{!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field, 2));
};


/**
 * @param {!Array<!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field>} value
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} returns this
*/
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.setFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field}
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.addFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.Field, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest} returns this
 */
proto.mlmbox.client.confirmation.v1.ConfirmationGuestConfirmRequest.prototype.clearFieldsList = function() {
  return this.setFieldsList([]);
};


goog.object.extend(exports, proto.mlmbox.client.confirmation.v1);
